var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "chatPageContainer__main",
      class: { nowInput: _vm.nowInput },
    },
    [
      _vm.marunage
        ? _c("div", { staticClass: "chatPageContainer__giftBanner" }, [
            _c("img", {
              staticClass: "chatPageContainer__giftBanner__pc",
              attrs: {
                src: _vm.marunage.amazon_gift_campaign
                  ? _vm.imageUrl("/gift/amazon_campaign_banner_1000_86.jpg")
                  : _vm.imageUrl("/gift/amazon_banner_1000_86.jpg"),
              },
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "chatPageContainer__giftBanner__sp",
              attrs: {
                src: _vm.marunage.amazon_gift_campaign
                  ? _vm.imageUrl("/gift/amazon_campaign_banner_614_86.jpg")
                  : _vm.imageUrl("/gift/amazon_banner_614_86.jpg"),
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "chatPageContainer__timeline" }, [
        _c("div", {
          staticClass: "ui vertical loader",
          class: { active: _vm.loading },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "chatItemContainer" },
          _vm._l(_vm.comments, function (comment) {
            return _c(
              "div",
              { key: comment.id },
              [
                comment.is_own && comment.text
                  ? _c("div", { staticClass: "chatItem" }, [
                      _c(
                        "div",
                        { staticClass: "chatItem__talk chatItem__talk--user" },
                        [
                          _c(
                            "div",
                            { staticClass: "chatItem__talkMainContainer" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chatItem__balloon chatItem__balloon--user",
                                },
                                [
                                  _c("div", {
                                    staticClass: "chatItem__text linebreak",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$options.filters.urlize(
                                          comment.text
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chatItem__metaContainer chatItem__metaContainer--user",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: comment.read,
                                          expression: "comment.read",
                                        },
                                      ],
                                      staticClass: "chatItem__readStatus",
                                    },
                                    [_vm._v("既読")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "chatItem__timestamp" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDatetime")(
                                            comment.created_at
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : comment.text
                  ? _c("div", { staticClass: "chatItem" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "chatItem__talk chatItem__talk--concierge",
                        },
                        [
                          _c("div", { staticClass: "chatItem__avatar" }, [
                            _vm.chat.marunage_shop
                              ? _c("img", {
                                  staticClass: "chatItem__avatarImage",
                                  attrs: {
                                    src: _vm.chat.marunage_shop.shop.main_image
                                      .urls.small_square,
                                  },
                                })
                              : _c("img", {
                                  staticClass: "chatItem__avatarImage",
                                  attrs: {
                                    src: _vm.imageUrl("/marunagekun.png"),
                                  },
                                }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "chatItem__talkMainContainer chatItem__talkMainContainer--concierge",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chatItem__balloon chatItem__balloon--concierge",
                                },
                                [
                                  comment.text
                                    ? _c("div", {
                                        staticClass: "chatItem__text linebreak",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$options.filters.urlize(
                                              comment.text
                                            )
                                          ),
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chatItem__metaContainer chatItem__metaContainer--concierge",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "chatItem__timestamp" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDatetime")(
                                            comment.created_at
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  comment.creator_role === "afadmin"
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "clickable chatItem__editCondition",
                                          on: {
                                            click: _vm.openMarunageEditDialog,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-pencil-alt",
                                          }),
                                          _vm._v(" 希望日時・人数の変更"),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : comment.json.type === "SUGGESTION_EXPLANATION"
                  ? _c("div", { staticClass: "chatItem" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "chatItem__talk chatItem__talk--concierge",
                        },
                        [
                          _c("div", { staticClass: "chatItem__avatar" }, [
                            _c("img", {
                              staticClass: "chatItem__avatarImage",
                              attrs: { src: _vm.imageUrl("/marunagekun.png") },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "chatItem__talkMainContainer chatItem__talkMainContainer--concierge",
                            },
                            [
                              _vm._m(0, true),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chatItem__metaContainer chatItem__metaContainer--concierge",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "chatItem__timestamp" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDatetime")(
                                            comment.created_at
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "clickable chatItem__editCondition",
                                      on: { click: _vm.openMarunageEditDialog },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-pencil-alt",
                                      }),
                                      _vm._v(" 希望日時・人数の変更"),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : comment.json.type === "CANDIDATE_EXPLANATION"
                  ? _c("div", { staticClass: "chatItem" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "chatItem__talk chatItem__talk--concierge",
                        },
                        [
                          _c("div", { staticClass: "chatItem__avatar" }, [
                            _c("img", {
                              staticClass: "chatItem__avatarImage",
                              attrs: { src: _vm.imageUrl("/marunagekun.png") },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "chatItem__talkMainContainer chatItem__talkMainContainer--concierge",
                            },
                            [
                              _vm._m(1, true),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chatItem__metaContainer chatItem__metaContainer--concierge",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "chatItem__timestamp" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDatetime")(
                                            comment.created_at
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "clickable chatItem__editCondition",
                                      on: { click: _vm.openMarunageEditDialog },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-pencil-alt",
                                      }),
                                      _vm._v(" 希望日時・人数の変更"),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : comment.json.type === "CANDIDATE_AND_SUGGESTION_EXPLANATION"
                  ? _c("div", { staticClass: "chatItem" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "chatItem__talk chatItem__talk--concierge",
                        },
                        [
                          _c("div", { staticClass: "chatItem__avatar" }, [
                            _c("img", {
                              staticClass: "chatItem__avatarImage",
                              attrs: { src: _vm.imageUrl("/marunagekun.png") },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "chatItem__talkMainContainer chatItem__talkMainContainer--concierge",
                            },
                            [
                              _vm._m(2, true),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chatItem__metaContainer chatItem__metaContainer--concierge",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "chatItem__timestamp" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDatetime")(
                                            comment.created_at
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "clickable chatItem__editCondition",
                                      on: { click: _vm.openMarunageEditDialog },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-pencil-alt",
                                      }),
                                      _vm._v(" 希望日時・人数の変更"),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : comment.json.type === "SUGGESTION"
                  ? _vm._l(comment.json.suggestions, function (suggest) {
                      return _c(
                        "div",
                        { key: suggest.id, staticClass: "chatItem" },
                        [
                          _c("div", { staticClass: "chatItem__shopPanel" }, [
                            _c(
                              "div",
                              {
                                staticClass: "chatItem__shopPanelImage",
                                style: _vm.backgroundImage(
                                  suggest.shop.main_image.urls.medium
                                ),
                              },
                              [
                                suggest.candidate
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "chatItem__shopPanelInfoBadge ui center aligned spOnly",
                                      },
                                      [_vm._m(3, true)]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "chatItem__shopPanelInfo" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "chatItem__shopPanelInfoText",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "chatItem__shopPanelTitle",
                                      },
                                      [_vm._v(_vm._s(suggest.shop.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "chatItem__shopPanelDescription",
                                      },
                                      [_vm._v(_vm._s(suggest.shop.title))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "chatItem__shopPanelAccess",
                                      },
                                      [_vm._v(_vm._s(suggest.shop.access))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      {
                                        staticClass: "chatItem__shopPanelMeta",
                                      },
                                      [
                                        _c("li", [
                                          _vm.lowestPrice(suggest.shop)
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "chatItem__shopPanelMetaLabel",
                                                },
                                                [_vm._v("予算")]
                                              )
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm._f("formatCurrency")(
                                                  _vm.lowestPrice(suggest.shop)
                                                )
                                              ) +
                                              "円〜\n                  "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "chatItem__shopPanelMetaLabel",
                                            },
                                            [_vm._v("最大人数")]
                                          ),
                                          _vm._v(" "),
                                          suggest.shop.max_count
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "chatItem__shopPanelMetaCapacityMax",
                                                },
                                                [
                                                  _vm._v(
                                                    "着席：" +
                                                      _vm._s(
                                                        suggest.shop.max_count
                                                      ) +
                                                      "人"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          suggest.shop.max_standing_count
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "chatItem__shopPanelMetaCapacitySeat",
                                                },
                                                [
                                                  _vm._v(
                                                    "立席：" +
                                                      _vm._s(
                                                        suggest.shop
                                                          .max_standing_count
                                                      ) +
                                                      "人"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                suggest.candidate
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "chatItem__shopPanelInfoBadge ui center aligned pcOnly",
                                      },
                                      [_vm._m(4, true)]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            suggest.shop.is_public &&
                            suggest.shop.rank !== "D" &&
                            suggest.shop.twilio_tel
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "chatItem__shopPanelTwilioTelContainer pcOnly",
                                  },
                                  [
                                    _c(
                                      "tel-link",
                                      {
                                        staticClass: "shopStoreTel__num",
                                        attrs: {
                                          value: suggest.shop.twilio_tel,
                                        },
                                      },
                                      [
                                        _c("i", { staticClass: "phone icon" }),
                                        _vm._v(
                                          _vm._s(suggest.shop.twilio_tel) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            suggest.shop.is_public && suggest.shop.rank !== "D"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "chatItem__shopPanelActionContainer",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "chatItem__shopPanelActionContainer__itemList",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "chatItem__shopPanelActionContainer__item chatItem__shopPanelCandidateMessage",
                                          },
                                          [
                                            suggest.candidate
                                              ? _c(
                                                  "a",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openCandidateDialog(
                                                          suggest.candidate
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "far fa-envelope",
                                                    }),
                                                    _c("span", [
                                                      _vm._v(
                                                        "お店からのメッセージを確認する"
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        suggest.shop.twilio_tel
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "chatItem__shopPanelActionContainer__item chatItem__shopPanelTwilioTelContainer spOnly",
                                              },
                                              [
                                                _c(
                                                  "tel-link",
                                                  {
                                                    staticClass:
                                                      "shopStoreTel__num",
                                                    attrs: {
                                                      value:
                                                        suggest.shop.twilio_tel,
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "phone icon",
                                                    }),
                                                    _vm._v(
                                                      _vm._s(
                                                        suggest.shop.twilio_tel
                                                      ) + "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "chatItem__shopPanelActionContainer__itemList",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "chatItem__shopPanelActionContainer__item",
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    suggest.shop.detail_url +
                                                    "?chat_id=" +
                                                    _vm.chat.id,
                                                  target: "_blank",
                                                },
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  { staticClass: "ui button" },
                                                  [_vm._v("詳しく見る")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "chatItem__shopPanelActionContainer__item",
                                          },
                                          [
                                            suggest.status === "none"
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass: "ui button",
                                                    class: {
                                                      "loading disabled":
                                                        suggest.waiting,
                                                      green: suggest.candidate,
                                                      orange:
                                                        !suggest.candidate,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        suggest.candidate
                                                          ? _vm.openShopChat(
                                                              suggest
                                                            )
                                                          : _vm.like(suggest)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        suggest.candidate
                                                          ? "チャットする"
                                                          : "空き確認"
                                                      ) + "\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "ui button disabled",
                                                    class: {
                                                      green:
                                                        suggest.candidate ||
                                                        suggest.status ===
                                                          "active",
                                                      orange: !(
                                                        suggest.candidate ||
                                                        suggest.status ===
                                                          "active"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        suggest.status_label
                                                      ) + "\n                  "
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      )
                    })
                  : comment.json.type === "LIKE"
                  ? _c("div", { staticClass: "chatItem" }, [
                      _c("div", { staticClass: "chatItem__userActionResult" }, [
                        _c("i", {
                          staticClass:
                            "fas fa-utensils chatItem__userActionResultIcon",
                        }),
                        _vm._v(
                          "「" +
                            _vm._s(comment.json.shop.name) +
                            "」に空き確認を押しました\n          "
                        ),
                      ]),
                    ])
                  : comment.json.type === "LIKE_ACCEPTED"
                  ? _c("div", { staticClass: "chatItem" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "chatItem__talk chatItem__talk--concierge",
                        },
                        [
                          _c("div", { staticClass: "chatItem__avatar" }, [
                            _vm.chat.marunage_shop
                              ? _c("img", {
                                  staticClass: "chatItem__avatarImage",
                                  attrs: {
                                    src: _vm.chat.marunage_shop.shop.main_image
                                      .urls.small_square,
                                  },
                                })
                              : _c("img", {
                                  staticClass: "chatItem__avatarImage",
                                  attrs: {
                                    src: _vm.imageUrl("/marunagekun.png"),
                                  },
                                }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "chatItem__talkMainContainer chatItem__talkMainContainer--concierge",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chatItem__balloon chatItem__balloon--concierge",
                                },
                                [
                                  _c("div", { staticClass: "chatItem__text" }, [
                                    _vm._v(
                                      "\n                「" +
                                        _vm._s(comment.json.shop.name) +
                                        "」の空席をお調べ致します。"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  空室の有無は各店舗の担当者からチャットにてご連絡しますので、直接詳細をご確認ください。"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  ご予約は店舗とのチャットでそのままご依頼いただけます。\n                  "
                                    ),
                                    comment.json.shop.twilio_tel
                                      ? _c("div", [
                                          _c("br"),
                                          _vm._v(
                                            "\n                    お急ぎの方はお電話でお問い合わせください。"
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                    ■" +
                                              _vm._s(comment.json.shop.name)
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "chatItem__twilioTelContainer",
                                            },
                                            [
                                              _c(
                                                "tel-link",
                                                {
                                                  staticClass:
                                                    "shopStoreTel__num",
                                                  attrs: {
                                                    value:
                                                      comment.json.shop
                                                        .twilio_tel,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "phone icon",
                                                  }),
                                                  _vm._v(
                                                    _vm._s(
                                                      comment.json.shop
                                                        .twilio_tel
                                                    ) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chatItem__metaContainer chatItem__metaContainer--concierge",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "chatItem__timestamp" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDatetime")(
                                            comment.created_at
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : comment.json.type === "MARUNAGE_UPDATED"
                  ? _c("div", { staticClass: "chatItem" }, [
                      _c("div", { staticClass: "chatItem__userActionResult" }, [
                        _vm._v("希望条件が更新されました"),
                      ]),
                    ])
                  : comment.json.type === "REPLY_RESERVATION_OK" ||
                    comment.json.type === "REPLY_RESERVATION_OK_WITH_CONSULT"
                  ? _c("div", { staticClass: "chatItem" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "chatItem__talk chatItem__talk--concierge",
                        },
                        [
                          _c("div", { staticClass: "chatItem__avatar" }, [
                            _vm.chat.marunage_shop
                              ? _c("img", {
                                  staticClass: "chatItem__avatarImage",
                                  attrs: {
                                    src: _vm.chat.marunage_shop.shop.main_image
                                      .urls.small_square,
                                  },
                                })
                              : _c("img", {
                                  staticClass: "chatItem__avatarImage",
                                  attrs: {
                                    src: _vm.imageUrl("/marunagekun.png"),
                                  },
                                }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "chatItem__talkMainContainer chatItem__talkMainContainer--concierge",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chatItem__balloon chatItem__balloon--concierge",
                                },
                                [
                                  _c("div", { staticClass: "chatItem__text" }, [
                                    _vm._v(
                                      "\n                  「" +
                                        _vm._s(comment.json.shop.name) +
                                        "」から"
                                    ),
                                    _c("b", [_vm._v("空室あり")]),
                                    _vm._v("の連絡がきています。"),
                                    _c("br"),
                                    _vm._v("\n                  詳細は"),
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: comment.json.chat_url },
                                      },
                                      [_vm._v("店舗とのチャット")]
                                    ),
                                    _vm._v("にて直接ご確認ください。"),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  ご予約は店舗とのチャットでそのままご依頼いただけます。\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chatItem__metaContainer chatItem__metaContainer--concierge",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "chatItem__timestamp" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDatetime")(
                                            comment.created_at
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : comment.json.type === "REPLY_RESERVATION_NG"
                  ? _c("div", { staticClass: "chatItem" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "chatItem__talk chatItem__talk--concierge",
                        },
                        [
                          _c("div", { staticClass: "chatItem__avatar" }, [
                            _vm.chat.marunage_shop
                              ? _c("img", {
                                  staticClass: "chatItem__avatarImage",
                                  attrs: {
                                    src: _vm.chat.marunage_shop.shop.main_image
                                      .urls.small_square,
                                  },
                                })
                              : _c("img", {
                                  staticClass: "chatItem__avatarImage",
                                  attrs: {
                                    src: _vm.imageUrl("/marunagekun.png"),
                                  },
                                }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "chatItem__talkMainContainer chatItem__talkMainContainer--concierge",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chatItem__balloon chatItem__balloon--concierge",
                                },
                                [
                                  _c("div", { staticClass: "chatItem__text" }, [
                                    _vm._v(
                                      "\n                  残念ながら「" +
                                        _vm._s(comment.json.shop.name) +
                                        "」は"
                                    ),
                                    _c("b", [_vm._v("空席がありません")]),
                                    _vm._v("でした。"),
                                    _c("br"),
                                    _vm._v("\n                  詳細は"),
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: comment.json.chat_url },
                                      },
                                      [_vm._v("店舗とのチャット")]
                                    ),
                                    _vm._v(
                                      "にて確認してください。\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chatItem__metaContainer chatItem__metaContainer--concierge",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "chatItem__timestamp" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDatetime")(
                                            comment.created_at
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : comment.json.type === "RESERVATION_OK"
                  ? _c("div", { staticClass: "chatItem" }, [_vm._m(5, true)])
                  : comment.json.type === "RESERVATION_OK_WITH_CONSULT"
                  ? _c("div", { staticClass: "chatItem" }, [_vm._m(6, true)])
                  : comment.json.type === "RESERVATION_NG"
                  ? _c("div", { staticClass: "chatItem" }, [_vm._m(7, true)])
                  : comment.json.type === "COMMIT_RESERVATION"
                  ? _c("div", { staticClass: "chatItem" }, [
                      _c("div", { staticClass: "chatItem__shopActionResult" }, [
                        _vm._v(
                          "\n          「" +
                            _vm._s(comment.json.shop.name) +
                            "」が仮予約を受付ました。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          まもなく、お店の担当者よりお電話にてご連絡致します。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          お電話をもって予約確定となります。\n          "
                        ),
                      ]),
                    ])
                  : comment.json.type === "EDIT_RESERVATION"
                  ? _c("div", { staticClass: "chatItem" }, [
                      _c("div", { staticClass: "chatItem__shopActionResult" }, [
                        _vm._v(
                          "\n          「" +
                            _vm._s(comment.json.shop.name) +
                            "」の予約が変更されました。\n          "
                        ),
                      ]),
                    ])
                  : comment.json.type === "CANCEL_RESERVATION"
                  ? _c("div", { staticClass: "chatItem" }, [
                      _c("div", { staticClass: "chatItem__shopActionResult" }, [
                        _vm._v(
                          "\n          「" +
                            _vm._s(comment.json.shop.name) +
                            "」の予約がキャンセルされました。\n          "
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ],
              2
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "chatPageContainer__chatFormContainer" }, [
        _c(
          "button",
          {
            staticClass:
              "chatPageContainer__proposalListButton ui button circular tiny yellow",
            on: { click: _vm.openBanquetsDialog },
          },
          [_vm._v("\n      候補のお店を見る\n    ")]
        ),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "ui form chatPageContainer__chatForm",
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.post()
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "field chatPageContainer__chatInputAreaContainer",
              },
              [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.postForm.model.text,
                      expression: "postForm.model.text",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "chatPageContainer__chatInputArea",
                  attrs: { rows: _vm.inputRows },
                  domProps: { value: _vm.postForm.model.text },
                  on: {
                    focus: _vm.onFocusTextarea,
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.postForm.model,
                        "text",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "ui primary large button chatPageContainer__chatSendButton",
                class: { loading: _vm.postForm.waiting },
                attrs: { type: "submit" },
              },
              [
                _c("i", {
                  staticClass:
                    "fas fa-paper-plane chatPageContainer__chatSendButtonIcon",
                }),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "chatItem__balloon chatItem__balloon--concierge" },
      [
        _c("div", { staticClass: "chatItem__text" }, [
          _vm._v("\n                  お店が見つかりました！"),
          _c("br"),
          _vm._v("\n                  ご紹介した店舗で"),
          _c("span", { staticClass: "chatItem__kininaruInlineBoxSuggestion" }, [
            _vm._v("空き確認"),
          ]),
          _vm._v("を押すと、ご希望の条件で利用できるかお調べいたします！"),
          _c("br"),
          _vm._v(
            "\n                  空室の有無は各店舗の担当者からチャットにてご連絡しますので、直接詳細をご確認ください。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ご予約は店舗とのチャットでそのままご依頼いただけます。\n                "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "chatItem__text--info" }, [
          _vm._v(
            "\n                希望日時や人数を変更されたい場合は、以下の「予約日時・人数の変更」から変更ください。"
          ),
          _c("br"),
          _vm._v(
            "\n                別なエリア、または複数のエリアでお探しの際はチャットにてお申し付けください。\n                "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "chatItem__balloon chatItem__balloon--concierge" },
      [
        _c("div", { staticClass: "chatItem__text" }, [
          _vm._v("\n                  店舗より立候補がありました！"),
          _c("br"),
          _vm._v("\n                  ご紹介した店舗で"),
          _c("span", { staticClass: "chatItem__kininaruInlineBoxCandidate" }, [
            _vm._v("チャットする"),
          ]),
          _vm._v(
            "を押すと、店舗様と直接連絡でき、条件などのご質問・ご相談ができます。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ご予約は店舗とのチャットでそのままご依頼いただけます。"
          ),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "\n                  また、他の店舗の紹介も必要でしたら、引き続きコンシェルジュのチャットにてご連絡ください。\n                "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "chatItem__text--info" }, [
          _vm._v(
            "\n                希望日時や人数を変更されたい場合は、以下の「予約日時・人数の変更」から変更ください。"
          ),
          _c("br"),
          _vm._v(
            "\n                別なエリア、または複数のエリアでお探しの際はチャットにてお申し付けください。\n                "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "chatItem__balloon chatItem__balloon--concierge" },
      [
        _c("div", { staticClass: "chatItem__text" }, [
          _vm._v(
            "\n                  コンシェルジュがご希望に見合うおすすめの会場をピックアップいたしました！"
          ),
          _c("br"),
          _vm._v(
            "\n                  ☆立候補店舗空きあり☆と表示されているお店はお客様のご希望とマッチしておりすぐにご案内が可能なお店です！\n                  "
          ),
          _c("span", { staticClass: "chatItem__kininaruInlineBoxCandidate" }, [
            _vm._v("チャットする"),
          ]),
          _vm._v("からやり取りが可能です。"),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v("\n                  また、他のおすすめ店舗は"),
          _c("span", { staticClass: "chatItem__kininaruInlineBoxSuggestion" }, [
            _vm._v("空き確認"),
          ]),
          _vm._v("を押すと、ご希望条件でご利用できるかお調べいたします！"),
          _c("br"),
          _vm._v(
            "\n                  ご不明点などございましたらお気軽にコンシェルジュチャットにお申し付け下さいませ。\n                "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "chatItem__shopPanelInfoBadgeText",
        staticStyle: { margin: "8px" },
      },
      [_vm._v("立候補店舗"), _c("br"), _vm._v("空きあり")]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chatItem__shopPanelInfoBadgeText" }, [
      _vm._v("立候補店舗"),
      _c("br"),
      _vm._v("空きあり"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chatItem__shopActionResult" }, [
      _vm._v("\n          [空席あり]"),
      _c("br"),
      _vm._v("\n          お席のご用意が可能です。"),
      _c("br"),
      _vm._v("\n          ご予約は本チャットにてご依頼ください。\n          "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chatItem__shopActionResult" }, [
      _vm._v("\n            [空席あり]"),
      _c("br"),
      _vm._v(
        "\n            お席のご用意が可能ですが、会場様とご相談が必要です。"
      ),
      _c("br"),
      _vm._v(
        "\n            条件をこちらのチャットでご確認ください。\n          "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chatItem__shopActionResult" }, [
      _vm._v("\n          [空席なし]"),
      _c("br"),
      _vm._v("\n          ご指定の条件ではお席をご用意できません。"),
      _c("br"),
      _vm._v(
        "\n          本チャットにて別な条件で空席の有無をご確認いただけます。\n          "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }